import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { IconButton } from '@mui/material';
import { useBreakpoints } from 'hooks';

import { ReactComponent as AIIcon } from 'assets/icons/AIIcon.svg';
import { ReactComponent as AIIconDefault } from 'assets/icons/AIIconDefault.svg';

import { BottomSliderControlled } from 'components/_basic/BottomSlider';
import { Button } from 'components/_basic/Button/Button';
import { AIAssistantAlertCard } from 'components/BusinessToolForm/components/AIAssistantAlertCard';

import styles from './GenerateWithAIButton.module.scss';

export interface IGenerateWithAiButtonProps {
  isLoading: boolean;
  aiDisabled: boolean;
  onClick: VoidFunction;
  isGenerateWholeDocumentDisabled: boolean;
}

export const GenerateWithAiButton: FC<IGenerateWithAiButtonProps> = ({
  isLoading,
  aiDisabled,
  onClick,
  isGenerateWholeDocumentDisabled,
}) => {
  const { t } = useTranslation();
  const { isAboveMobile } = useBreakpoints();

  const iconRender = aiDisabled ? <AIIconDefault className={styles.disabledIcon} /> : <AIIcon />;

  if (isAboveMobile) {
    return (
      <Button
        size="large"
        variant="outlined"
        color="gradient"
        disabled={aiDisabled || isLoading}
        buttonClassName={styles.aiButton}
        onClick={onClick}
      >
        {t('ai.generateWithAI')} {iconRender}
      </Button>
    );
  } else if (isGenerateWholeDocumentDisabled) {
    return (
      <IconButton size="medium" onClick={onClick}>
        <AIIcon />
      </IconButton>
    );
  }

  return (
    <BottomSliderControlled
      renderController={(onClick) => (
        <IconButton size="medium" onClick={onClick}>
          <AIIcon />
        </IconButton>
      )}
    >
      {({ onClose }) => <AIAssistantAlertCard onCardClose={onClose} />}
    </BottomSliderControlled>
  );
};
